import type { FunctionComponent } from 'react';

import logoBlack from '@treneo/assets/images/logo-black.svg';
import logoWhite from '@treneo/assets/images/logo-white.svg';
import { Themes } from '@treneo/shared/constants';
import { useApplicationTheme } from '@treneo/shared/themes';

import { StyledApplicationLogo } from './application-logo.styles';

type Props = {
  className?: string;
};

export const ApplicationLogo: FunctionComponent<Props> = ({ className }) => {
  const currentTheme = useApplicationTheme();
  const src = currentTheme === Themes.dark ? logoWhite : logoBlack;

  return <StyledApplicationLogo src={src} className={className} />;
};
